module.exports = __webpack_public_path__ + "img/checkout-shoes.7d09194c.svg";